import {ClsUtil} from '../../../util/cls-util';
import {ClsConfig} from '../../../util/cls-config';
import {AppInfoService} from '../../../core/services/app-info.service';
import {PresupuestoComponent} from '../../../componentes/01-presupuesto/presupuesto/presupuesto.component';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {IgcContentPane} from '@infragistics/igniteui-dockmanager';
import {EnumMenuOpIDPrincipal} from '../../../core/models/enum/enum-menus-opciones';
import {MatrizActivoComponent} from '../../../componentes/01-presupuesto/matrices/matriz-activo/matriz-activo.component';
import {ClsObjExplosionDeInsumos} from '../menu-presupuesto/cls-obj-explosion-de-insumos';
import {ClsObjGenerico} from '../../util/cls-obj-generico';
import {
  ClsColDiferencia,
  DiferenciasComponent
} from '../../../componentes/util/ventanas/diferencias/diferencias.component';
import {VtnGenericaComponent} from '../../../componentes/util/ventanas/vtn-generica/vtn-generica.component';
import {first} from 'rxjs/operators';
import {firstValueFrom} from 'rxjs';
import {ClsArbolPartida} from "../../../core/models/cls-partida";
import { ClsCatalogosExpIns } from 'src/app/core/models/cls-catalogo-general';
import {ClsMatriz} from "../../../core/models/cls-matriz";
import {inject} from "@angular/core";
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

export class ClsObjCopiado extends ClsConfig {
  public columnasRequeridas: string[] = [];
  public columnas: string[] = [];
  public mObjExpInsumos: ClsObjExplosionDeInsumos = new ClsObjExplosionDeInsumos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  // mapas
  public mMapPartidas: Map<string, ClsArbolPartida> = new Map<string, ClsArbolPartida>();
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);
  private tipoMsg = inject(TipoMensajesService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);
  constructor() {
    super();
  }

  public validarCamposRequeridos(datosPegados: any[]) {
    // La primer fila son encabezados
    const encabezados: any = datosPegados.shift() || [];
    this.columnas = [];
    for (let encabezado of encabezados) {
      if (encabezado.charCodeAt(encabezado.length - 1) === 13) {
        encabezado = encabezado.slice(0, -1);
      }
      this.columnas.push(encabezado);
    }
    let campo: string;
    let campo2: string;
    for (campo of this.columnasRequeridas) {
      campo2 = campo;
      if (this.columnas.findIndex(value => {
        // value = ClsUtil.quitarAcentos(value);
        // campo = ClsUtil.quitarAcentos(campo);
        // if (value.toLowerCase() === campo.toLowerCase()) {
        //   return 1;
        // }
        if (value === campo) {
          return 1;
        }
      }) === -1) {
        throw new Error(this.getTranslationsFaltaColumna(campo2));
      }
    }
    return true;
  }

  public procesarDatos(datosPegados: any[], aplicarTrim: boolean): any[] {
    const datosProcesados: any[] = [];
    try {
      for (const dato of datosPegados) {
        const obj: any = {};
        let i: number;
        for (i = 0; i < this.columnas.length; i++) {
          if (i < dato.length) {
            let valor: string = dato[i];
            if (valor.charCodeAt(valor.length - 1) === 13) {
              valor = valor.slice(0, -1);
            }
            if (aplicarTrim) {
              valor = valor.trim();
            }
            obj[this.columnas[i]] = valor;
          } else {
            obj[this.columnas[i]] = null;
          }
        }
        datosProcesados.push(obj);
      }
      return  datosProcesados;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async validarDiferencias(datos: any): Promise<any> {
    let dataDirefencia: ClsColDiferencia[];
    if (this.infPpto.pptoActivoCompletoJSON.CatExpIns.length > 0) {
      dataDirefencia = this.verificarDiferencias(datos);
      //  invocar ventana de diferencia, siempre y cuando sea mayor que 0
      if (dataDirefencia.length > 0) {
        const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
        // vtnGenerico.verIconoMaxMin = true;
        vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
        const vtnDiferencia = vtnGenerico.crearComponente(DiferenciasComponent);
        vtnDiferencia.dataDiferencias = dataDirefencia;
        vtnDiferencia.open();
        // esperamos que responda algo la ventanan de diferencia(sustituir o mantener o cancelar)
        // first() por default regresa o filtra el primer valor, en caso de regresar mas de uno, tener cuidado de como usarlo
        // first() = https://www.learnrxjs.io/learn-rxjs/operators/filtering/first
        let dif: ClsColDiferencia[] = await firstValueFrom(vtnDiferencia.dataRespuesta.pipe(first()));
        // si resp es null quiere decir que se cancelo el proceso desde la ventana de diferencia
        if (!ClsUtil.esNulo(dif)) {
          // se filtran los datos que se tienen que mantener para hacer el cambio y mostrarlo en el grid
          dif = dif.filter(value => value.Accion === this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.MANTENER'));
          dif.forEach(value => {
            const colCodigo: string = this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_CODIGO');
            // buscamos el codigo para cambiar el valor
            const val: any = datos.find(value1 => value1[colCodigo] === value.Codigo);
            if (!ClsUtil.esNulo(val)) {
              val[value.Campo] = value.ValorActual;
            }
          });
          return datos;
        }
        return undefined;
      } else {
        return datos;
      }
    } else {
      return datos;
    }
  }

  public verificarDiferencias(data: any): ClsColDiferencia[] {
    const dataDirefencia: ClsColDiferencia[] = [];
    const accion: string = this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.MANTENER');
    data.forEach(registro => {
      const valorCodigo: string = registro[this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_CODIGO')];
      if (!ClsUtil.esNulo(valorCodigo)) {
        const dataExpIns: ClsCatalogosExpIns = this.mObjExpInsumos.buscarCodigoEnExpIns(valorCodigo);
        if (!ClsUtil.esNulo(dataExpIns)) {
          // validar que la columna Descripcion exista
          const campoDes: string = this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_DESCRIPCION');
          const valorDes: string = registro[campoDes];
          if (!ClsUtil.esNulo(valorDes)) {
            if (dataExpIns.Descripcion !== valorDes) {
              dataDirefencia.push({Codigo: dataExpIns.Codigo, Campo: campoDes, ValorActual: dataExpIns.Descripcion, ValorNuevo: valorDes, Accion: accion});
            }
          }
          // validar que la columna DescripcionLarga exista
          const campoDesLarga: string = this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA');
          const valorDesLarga: string = registro[campoDesLarga];
          if (!ClsUtil.esNulo(valorDesLarga)) {
            if (dataExpIns.DescripcionLarga !== valorDesLarga) {
              dataDirefencia.push({Codigo: dataExpIns.Codigo, Campo: campoDesLarga, ValorActual: dataExpIns.DescripcionLarga, ValorNuevo: valorDesLarga, Accion: accion});
            }
          }
          // validar que la columna Familia exista
          const campoFamilia: string = this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_FAMILIA');
          const valorFamilia: string = registro[campoFamilia];
          if (!ClsUtil.esNulo(valorFamilia)) {
            if (dataExpIns.Familia !== valorFamilia.toUpperCase()) {
              dataDirefencia.push({Codigo: dataExpIns.Codigo, Campo: campoFamilia, ValorActual: dataExpIns.Familia, ValorNuevo: valorFamilia, Accion: accion});
            }
          }
          // validar que la columna Unidad exista
          const campoUnidad: string = this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_UNIDAD');
          const valorUnidad: string = registro[campoUnidad];
          if (!ClsUtil.esNulo(valorUnidad)) {
            if (dataExpIns.Unidad !== valorUnidad.toUpperCase()) {
              dataDirefencia.push({Codigo: dataExpIns.Codigo, Campo: campoUnidad, ValorActual: dataExpIns.Unidad, ValorNuevo: valorUnidad, Accion: accion});
            }
          }
          // validar que la columna Tipo exista
          const campoTipo: string = this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_TIPO_INSUMO');
          const valorTipo: string = registro[campoTipo];
          if (!ClsUtil.esNulo(valorTipo)) {
            if (dataExpIns.Tipo.toString() !== valorTipo) {
              dataDirefencia.push({Codigo: dataExpIns.Codigo, Campo: campoTipo, ValorActual: dataExpIns.Tipo.toString(), ValorNuevo: valorTipo, Accion: accion});
            }
          }
          //  validar que la columna EsPorcentaje existe
          const campoTipoPorc: string = this.mObjGenerico.getTranslationsSubject('GRIDS.EXP_INSUMO.COL_TIPO_%');
          const valorTipoPorc: string = registro[campoTipoPorc];
          if (!ClsUtil.esNulo(valorTipoPorc)) {
            if (dataExpIns.TipoPorcentaje.toString() !== valorTipoPorc) {
              dataDirefencia.push({Codigo: dataExpIns.Codigo, Campo: campoTipoPorc, ValorActual: dataExpIns.TipoPorcentaje.toString(), ValorNuevo: valorTipoPorc, Accion: accion});
            }
          }
        }
      }
    });
    return dataDirefencia;
  }

  public async copiarRegistroAPartidaActiva(idsCatalogo: bigint[], catExpIns: ClsCatalogosExpIns[], mostrarLoader: boolean = true) {
    let dataExpIns: ClsCatalogosExpIns[] = [];
    const rowSeleccionados: bigint[] = idsCatalogo;
    const pptoComponente: PresupuestoComponent = this.infPpto.dmPrincipal.dmSecundarioPptoActivo.Ppto;
    const partidaActiva: ClsArbolPartida = pptoComponente.partidaComponent.partidaSeleccionado;
    try {
      if (mostrarLoader) {
        this.tipoMsg.mostrarMasMsgsCustomizado(this.mObjExpInsumos.getTranslationsAwaitRegistrosCopiando('MENSAJES.WAIT.COPIANDO_REGISTROS_PARTIDA_ACTIVA', rowSeleccionados.length, partidaActiva.Partida));
      }
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.VALIDANDO_INF');
      this.validarCopiarRegistroAPptoActivo(rowSeleccionados);
      dataExpIns = this.getRowCatalogo(rowSeleccionados, catExpIns);
      await this.activarObraActiva(dataExpIns);
      this.limpiarCantidadaCopiar(dataExpIns);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async copiarRegistroAMatrizActiva(idsCatalogo: bigint[], catExpIns: ClsCatalogosExpIns[], mostrarLoader: boolean = true) {
    let dataExpIns: ClsCatalogosExpIns[] = [];
    let rowSeleccionados: bigint[] = [];
    let matrizActivoC: MatrizActivoComponent;
    let matriz: ClsMatriz;
    try {
      rowSeleccionados = idsCatalogo;
      matrizActivoC = this.infPpto.dmPrincipal.dmSecundarioPptoActivo.MActivo;
      if (ClsUtil.esNulo(matrizActivoC)) {
        throw new Error('MENSAJES.ALERT.MATRIZ_ACTIVA');
      }
      matriz = matrizActivoC.dataMatricesTemp[matrizActivoC.index];
      if (mostrarLoader) {
        this.tipoMsg.mostrarMasMsgsCustomizado(this.mObjExpInsumos.getTranslationsAwaitRegistrosCopiando('MENSAJES.WAIT.COPIANDO_REGISTROS_MATRIZ_ACTIVA', rowSeleccionados.length, matriz.CodigoMatriz));
      }
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.VALIDANDO_INF');
      this.validarCopiarRegistroAMatrizActiva(idsCatalogo, matriz.CodigoMatriz, catExpIns);
      dataExpIns = this.getRowCatalogo(rowSeleccionados, catExpIns);
      await this.activarTabMatriz(dataExpIns);
      this.limpiarCantidadaCopiar(dataExpIns);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public validarCopiarRegistroAPptoActivo(idsCatalogo: bigint[]) {
    const rowSeleccionados: bigint[] = idsCatalogo;
    const pptoComponente: PresupuestoComponent = this.infPpto.dmPrincipal.dmSecundarioPptoActivo.Ppto;
    const partidaActiva: ClsArbolPartida = pptoComponente.partidaComponent.partidaSeleccionado;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      // validar que tenga seleccionado la partida
      if (ClsUtil.esNulo(partidaActiva)) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_PARTIDA');
      }
      if (ClsUtil.esNulo(partidaActiva.IdPresupuestoPartida)) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_PARTIDA');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public validarCopiarRegistroAMatrizActiva(idsCatalogo: bigint[], codigo: string, dataExpIns: ClsCatalogosExpIns[]) {
    const rowSeleccionados: bigint[] = idsCatalogo;
    const dataExpIns2: ClsCatalogosExpIns[] = [];
    const panelMatriz: IgcContentPane = this.infPpto.dmPrincipal.dmSecundarioPptoActivo.getPaneles('Matriz')[0];
    const mapExpIns: Map<bigint, ClsCatalogosExpIns> = ClsUtil.crearMapIdCatalogo(dataExpIns);
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      // validar que este abierta la matriz
      if (panelMatriz.hidden) {
        throw new Error('MENSAJES.ALERT.MATRIZ_ACTIVA');
      }
      for (const rowsKey of rowSeleccionados) {
        const rowData: ClsCatalogosExpIns = mapExpIns.get(rowsKey);
        dataExpIns2.push(rowData);
      }
      const index: number = dataExpIns2.findIndex(value => value.Codigo === codigo);
      if (index !== -1) {
        this.limpiarCantidadaCopiar(dataExpIns);
        throw new Error(this.mObjExpInsumos.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.EXP_INSUMO.COL_CODIGO'), codigo));
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async activarTabMatriz(dataExpIns: ClsCatalogosExpIns[]) {
    const panelMatriz: IgcContentPane = this.infPpto.dmPrincipal.dmSecundarioPptoActivo.getPaneles('Matriz')[0];
    const panelesPrin: IgcContentPane[] = this.infPpto.dmPrincipal.getPaneles(EnumMenuOpIDPrincipal.PptoActivo);
    this.infPpto.dmPrincipal.refrescarLayou(this.infPpto.dmPrincipal.rutaAux.indexOf(panelesPrin[0]));
    this.infPpto.dmPrincipal.dmSecundarioPptoActivo.refrescarLayou(this.infPpto.dmPrincipal.dmSecundarioPptoActivo.rutaAux.indexOf(panelMatriz));
    this.infPpto.esPptoMaestro = false;
    // emitir los datos a la matriz
    await this.infPpto.dmPrincipal.dmSecundarioPptoActivo.MActivo.agregarMatrizActiva(dataExpIns);
  }

  public async activarObraActiva(dataExpIns: ClsCatalogosExpIns[]) {
    await this.setFocusObraActiva();
    // emitir los datos a los conceptos
    await this.infPpto.dmPrincipal.dmSecundarioPptoActivo.Ppto.agregarPptoActivo(dataExpIns);
  }
  public async setFocusObraActiva() {
    const panelesPrin: IgcContentPane[] = this.infPpto.dmPrincipal.getPaneles(EnumMenuOpIDPrincipal.PptoActivo);
    const paneles: IgcContentPane[] = this.infPpto.dmPrincipal.dmSecundarioPptoActivo.getPaneles('MENSAJES.GRALS.PPTO');
    const panelPpto: IgcContentPane = paneles.find(value => value.contentId === 'Presupuesto');
    // hacer focus al tab de la obra activa
    this.infPpto.dmPrincipal.refrescarLayou(this.infPpto.dmPrincipal.rutaAux.indexOf(panelesPrin[0]));
    this.infPpto.dmPrincipal.dmSecundarioPptoActivo.refrescarLayou(this.infPpto.dmPrincipal.dmSecundarioPptoActivo.rutaAux.indexOf(panelPpto));
    this.infPpto.esPptoMaestro = false;
  }

  public limpiarCantidadaCopiar(dataExpIns: ClsCatalogosExpIns[]) {
    dataExpIns.forEach(value => {
      value.CantidadACopiar = '';
    });
  }

  private getRowCatalogo(rowSeleccionados: bigint[], catExpIns: ClsCatalogosExpIns[]): ClsCatalogosExpIns[] {
    const dataExpIns: ClsCatalogosExpIns[] = [];
    const mapExpIns: Map<bigint, ClsCatalogosExpIns> = ClsUtil.crearMapIdCatalogo(catExpIns);
    try {
      for (const rowsKey of rowSeleccionados) {
        const rowData: ClsCatalogosExpIns = mapExpIns.get(rowsKey);
        // validar que no se mande CF que participe en un CH
        if (ClsUtil.CFParticipaEnCostoHorario(rowData.IdCatalogo, this.infPpto)) {
          const mensaje = this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.CF_ANALISIS_2');
          throw new Error(mensaje.replace('{0}', rowData.Codigo));
        }
        // si no tiene cantidad, se agrega un default
        if (rowData.CantidadACopiar === '') {
          rowData.CantidadACopiar = '1';
        }
        rowData.DesdeMaestro = (this.infPpto.esPptoMaestro || this.infPpto.checkMaestroExpIns);
        dataExpIns.push(rowData);
      }
    } catch (e) {
      throw new Error(e.message);
    }
    return dataExpIns;
  }

  //#region mapas
  // mapas
  public agregarPartidaSiNoExiste(partidaPadreAux: string, partidaAux: string, clsPartida: ClsArbolPartida) {
    const llave = `${partidaPadreAux.trim().toUpperCase()}_${partidaAux.trim().toUpperCase()}`;
    if (!this.mMapPartidas.has(llave)) {
      this.mMapPartidas.set(llave, clsPartida);
    }
  }
  //#region
  public getTranslationsFaltaColumna(columna: string): string {
    return ClsUtil.getTranslations(['MENSAJES.ERROR.FALTA_COLUMNA'], this.infApp)['MENSAJES.ERROR.FALTA_COLUMNA'].toString().replace('{0}', columna);
  }
}
